import { Button } from "react-bootstrap";
import SpinnerButton from "../spinner-button/spinner-button";
import { useTranslation } from "react-i18next";

const SaveFiltersButton = ({ size = "md", onClick, isSubmitting }) => {
  const { t } = useTranslation();
  return (
    <div className="px-0">
      {!isSubmitting ? (
        <Button
          size={size}
          className="mb-3"
          variant="primary"
          onClick={onClick}
        >
          {t("funnelFilters.saveBtn")}
        </Button>
      ) : (
        <SpinnerButton
          btnStyle="mb-3 btn-primary"
          btnText={t("funnelFilters.saveBtn")}
        />
      )}
    </div>
  );
};
export default SaveFiltersButton;
